import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false });
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/homeson',
    name: 'homeson',
    // 重定向
    redirect: 'homeson/website',
    component: () => import(/* webpackChunkName: "homeson" */ '../views/homeson.vue'),
    children: [
      {
        path: 'website',
        name: 'website',
        component: () => import(/* webpackChunkName: "website" */ '../views/WebsiteView.vue'),
      },
      {
        path: 'updatalog',
        name: 'updatalog',
        component: () => import(/* webpackChunkName: "updatalog" */ '../views/updatalog.vue'),
      },
      {
        path: 'test',
        name: 'test',
        component: () => import(/* webpackChunkName: "test" */ '../views/test.vue'),
      },
    ]
  },
  {
    path: '/findView',
    name: 'findView',
    component: () => import(/* webpackChunkName: "findView" */ '../views/findView.vue'),
  }
]

const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, from) => {
  NProgress.start()
})

router.afterEach(to => {
  NProgress.done()
})

export default router
